import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  CloudData,
  CloudOptions,
  ZoomOnHoverOptions,
} from 'angular-tag-cloud-module';
import * as d3 from 'd3';
import _ from 'lodash';

import { Idea } from '../../../models/Sessions/Idea/Idea';

const COLOR_SMALL = '#39d';
const COLOR_LARGE = '#8dd9ff';

const WEIGHT_SMALL = 4;
const WEIGHT_LARGE = 5;

@Component({
  selector: 'app-expertise-word-cloud',
  templateUrl: './expertise-word-cloud.component.html',
  styleUrls: ['./expertise-word-cloud.component.scss'],
})
export class ExpertiseWordCloudComponent implements OnInit {
  @Input() ideas: Idea[];
  @ViewChild('divParent', { static: true }) divParent: ElementRef;

  options: CloudOptions = {
    // if width is between 0 and 1 it will be set to the width of the upper element multiplied by the value
    width: 400,
    // if height is between 0 and 1 it will be set to the height of the upper element multiplied by the value
    height: 300,
    overflow: false,
  };

  data: CloudData[];
  wordCloudZoomOnHoverOptions: ZoomOnHoverOptions = {
    scale: 1.3,
    transitionTime: 0.2,
    delay: 0.0,
  };

  ngOnInit() {
    this.options.width = this.divParent.nativeElement.offsetWidth;
    this.options.height = this.divParent.nativeElement.offsetHeight;

    const allTags = _.flatten(
      this.ideas.map(idea => (idea['tags'] ? idea['tags'] : [])),
    ).slice(0, 2000);
    const groupedTags = _.groupBy(allTags, _.identity);

    const maxCount = _.max(_.values(groupedTags).map(tags => tags.length));
    const minCount = _.min(_.values(groupedTags).map(tags => tags.length));

    const colorScale = d3.scaleLinear(
      [minCount - 1, maxCount],
      [COLOR_SMALL, COLOR_LARGE],
    );

    const sizeScale = d3.scaleLinear(
      [minCount - 1, maxCount],
      [WEIGHT_SMALL, WEIGHT_LARGE],
    );

    this.data = _.keys(groupedTags).map(tag => {
      return {
        text: tag,
        weight: sizeScale(groupedTags[tag].length),
        color: `${colorScale(groupedTags[tag].length)}`,
      };
    });
  }
}
